/* eslint-disable import/first */
import React, { useState } from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import Button from '@material-ui/core/Button';
import { useNavigate } from '@reach/router';
import { FormattedMessage, useIntl } from 'react-intl';

const { selectFirstCategory } = Slices.categorySlice;
import { generateCategoryRoute } from 'spwa-ui-library/esm/utils/path';
import icon from './images/exploreMenu.svg';
import downloadImg from './images/download.jpg';
import css from './index.module.scss';

export default function ExploreMenuHome({ widgetData }) {
  const firstCategory = useSelector(selectFirstCategory);
  const intl = useIntl();
  const navigate = useNavigate();

  const [exploreLink, setExploreLink] = useState(null);

  React.useEffect(() => {
    const exploreMenuPath = generateCategoryRoute({
      category: firstCategory,
      locale: intl?.locale,
    });
    setExploreLink(exploreMenuPath);
  }, [firstCategory, intl.locale]);

  const navigatePage = (e) => {
    e.preventDefault();
    navigate(exploreLink);
  };
  return (
    <div className={css.root}>
      <div className={css.download}>
        <img src={downloadImg} alt="" />
      </div>
      {/* <div className={css.img}>
        <img src={icon} width="360" height="180" alt="" />
      </div>
      <div className={css.content}>
        <FormattedMessage
          id="add_herbs_spices"
          defaultMessage="Adding 11 herbs and spices, Explore our menu and add items to your cart."
        />
      </div>
      <Button href={exploreLink} variant="contained" color="primary" onClick={navigatePage}>
        <FormattedMessage id="explore_menu" defaultMessage="Explore Menu" />
      </Button> */}
    </div>
  );
}
